<template>
    <div class="content">
        <!-- eslint-disable vue/no-v-html -->
        <span v-html="infotext" />
        <dynamic-table
            class="table"
            :table-data="dynamicTableData"
        />
        <span v-html="includesText" />
        <!--eslint-enable-->
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-facing-decorator"
    import DynamicRightSlotData from "@/models/dynamicrighslotdata"
    import DynamicTable from "@/components/DynamicTable.vue"
    import TableData from "@/models/tabledata"

    @Component({
        components: {
            "dynamic-table": DynamicTable
        }
    })
    export default class BittimittariVuorokaudenaikaanPohjautuvatRuudut extends Vue {
        get rightSlotData(): DynamicRightSlotData {
            return this.$store.getters.rightSlotData
        }

        get infotext(): string | undefined {
            return this.$t("App.BittimittariVuorokaudenaikaanPohjautuvatRuudut.Rightslot.Infotext")
        }

        get includesText() {
            return this.$t("App.BittimittariVuorokaudenaikaanPohjautuvatRuudut.Rightslot.Includes")
        }

        get dynamicTableData() {
            return new TableData(
                [this.$t("App.BittimittariVuorokaudenaikaanPohjautuvatRuudut.Rightslot.Table.Header.GridLevel"), this.$t("App.BittimittariVuorokaudenaikaanPohjautuvatRuudut.Rightslot.Table.Header.AtLeast")],
                [[this.$t("App.BittimittariVuorokaudenaikaanPohjautuvatRuudut.Rightslot.Table.Row1.GridLevel"), this.$t("App.BittimittariVuorokaudenaikaanPohjautuvatRuudut.Rightslot.Table.Row1.Value")],
                 [this.$t("App.BittimittariVuorokaudenaikaanPohjautuvatRuudut.Rightslot.Table.Row2.GridLevel"), this.$t("App.BittimittariVuorokaudenaikaanPohjautuvatRuudut.Rightslot.Table.Row2.Value")]],
                null)
        }
    }
</script>

<style scoped>
   /* Deep selectorilla tyyli saadaan vaikuttamaan kielitermin sisältämiin <p> tageihin */
   :deep(p) {
        margin-bottom: 1rem !important;
    }

    .table {
        margin-bottom: 2rem;
    }
</style>
